module.exports = __webpack_public_path__ + "img/Matematicas III.b30c9479.png";